import { Grid } from "@material-ui/core";
import React, { useContext } from "react";

import { AuthContext } from "../contexts/AuthContext";
import ListUsers from "../lib/ListUsers";

import { BasePage } from "./BasePage";

export const UserManagementPage: BasePage = () => {
  const auth = useContext(AuthContext);
  return (
    <div>
      <Grid container spacing={3}>
        <ListUsers callerAgency={auth.agency} />
      </Grid>
    </div>
  );
};
